import React, { useContext, useEffect } from "react";
import "../css/DotRing.css";
import useMousePosition from "../useMousePosition";
import { MouseContext } from "../mouse-context";
import Home from './Home'
import $ from 'jquery'

const DotRing = () => {
    const { cursorType, cursorChangeHandler } = useContext(MouseContext);
    const { x, y } = useMousePosition();

    useEffect(() => {
        $(".service__1__img").css("left", `${x - 250}px`);
        $(".service__2__img").css("left", `${x - 250}px`);
        $(".service__3__img").css("left", `${x - 250}px`);
    }, [x])
    return (
        <div className={"cursor__bg" + cursorType} style={{ left: `${x}px`, top: `${y}px` }}        >
            <div
                style={{ left: `${x}px`, top: `${y}px` }}
                className={"ring " + cursorType}
            ></div>
            <div
                className={"dot " + cursorType}
                style={{ left: `${x}px`, top: `${y}px` }}
            ></div>
        </div>
    );
};

export default DotRing;
